import { render, staticRenderFns } from "./activity-edit.vue?vue&type=template&id=47645a1c&scoped=true&"
import script from "./activity-edit.vue?vue&type=script&lang=js&"
export * from "./activity-edit.vue?vue&type=script&lang=js&"
import style0 from "./activity-edit.vue?vue&type=style&index=0&id=47645a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47645a1c",
  null
  
)

export default component.exports